import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateBanner } from "./createBanner.request";
import { CreateBannerResponse } from "./createBanner.types";

const useCreateBanner = (
  options?: MutationOptions<CreateBannerResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateBanner,
    ...options
  });
};

export default useCreateBanner;
